interface Props {
  className?: string;
}

const InsuranceShield: React.FC<Props> = ({ className }) => (
  <svg
    className={className}
    width="126"
    height="126"
    viewBox="0 0 126 126"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M59.556 123.648C92.4479 123.648 119.112 96.9839 119.112 64.092C119.112 31.2001 92.4479 4.53601 59.556 4.53601C26.6641 4.53601 0 31.2001 0 64.092C0 96.9839 26.6641 123.648 59.556 123.648Z"
      fill="#FFE2AF"
    />
    <path
      d="M118.65 74.718L122.682 79.758C123.732 81.102 123.396 83.034 121.926 83.916C110.04 91.014 61.3202 116.97 19.9082 95.508"
      fill="#FEC865"
    />
    <path
      d="M99.4561 40.194L99.4141 50.862V50.904C99.4141 51.072 99.4141 51.24 99.4141 51.45L99.4561 40.782C99.4561 40.572 99.4561 40.404 99.4561 40.236C99.4561 40.236 99.4561 40.236 99.4561 40.194Z"
      fill="#40AE87"
    />
    <path
      d="M122.305 67.284L122.263 77.952C122.263 78.288 122.053 78.582 121.591 78.834C120.079 79.674 117.517 81.018 114.115 82.614L114.157 71.946C117.559 70.35 120.121 69.006 121.633 68.166C122.095 67.914 122.305 67.578 122.305 67.284Z"
      fill="#008254"
    />
    <path
      d="M114.156 71.946L114.114 82.572L100.674 88.326V77.658L114.156 71.946Z"
      fill="#008254"
    />
    <path
      d="M12.7266 79.716L12.7686 69.048C12.7686 74.256 14.7426 79.548 19.6566 84.63L19.6146 95.298C14.7006 90.216 12.7266 84.924 12.7266 79.716Z"
      fill="#40AE87"
    />
    <path
      d="M19.9932 84.84L19.9512 95.508L19.6152 95.298L19.6572 84.63L19.9932 84.84Z"
      fill="#5D9ED6"
    />
    <path
      d="M98.7001 39.144C99.2041 39.438 99.4981 39.816 99.4561 40.278C99.2461 44.1 100.926 54.39 121.212 66.108C121.38 66.192 121.506 66.276 121.674 66.36C122.556 66.864 122.556 67.662 121.674 68.166C120.162 69.006 117.6 70.35 114.198 71.946L100.716 77.7C79.8841 85.68 48.0901 93.954 19.9921 84.882L19.6981 84.672C-3.82189 60.396 39.5221 31.542 48.5101 25.956C49.3501 25.452 50.7361 25.452 51.5761 25.956C51.7441 26.04 51.8701 26.124 52.0381 26.208C72.3661 37.926 90.0901 38.85 96.7261 38.724C97.6501 38.724 98.2381 38.892 98.7001 39.144Z"
      fill="#40AE87"
    />
    <path
      d="M100.674 77.658L100.632 88.326C79.8002 96.306 48.0062 104.58 19.9082 95.508L19.9502 84.84C48.0482 93.912 79.8842 85.68 100.674 77.658Z"
      fill="#008254"
    />
    <path
      d="M111.468 64.47V67.116C111.468 67.41 111.3 67.662 110.922 67.872C109.62 68.586 107.436 69.72 104.496 71.106V68.46C107.394 67.074 109.62 65.94 110.922 65.226C111.3 65.016 111.468 64.764 111.468 64.47Z"
      fill="#008254"
    />
    <path
      d="M104.497 68.46V71.148L92.9471 76.062L92.9891 73.416L104.497 68.46Z"
      fill="#008254"
    />
    <path
      d="M17.6405 68.67V66.024C17.6405 70.518 19.3205 75.012 23.5625 79.38V82.026C19.3205 77.658 17.6405 73.164 17.6405 68.67Z"
      fill="#BAE1D5"
    />
    <path
      d="M23.8145 79.548V82.194L23.5625 82.026V79.338L23.8145 79.548Z"
      fill="#008254"
    />
    <path
      d="M92.9893 73.416V76.062C75.1813 82.908 47.8813 89.964 23.8573 82.194V79.548C47.8813 87.318 75.1393 80.262 92.9893 73.416Z"
      fill="#008254"
    />
    <path
      d="M110.922 63.714C111.678 64.134 111.678 64.848 110.922 65.268C109.62 65.982 107.436 67.116 104.496 68.502L92.9458 73.416C75.1378 80.262 47.8378 87.318 23.8138 79.548L23.5618 79.338C3.44379 58.59 40.5718 33.852 48.2578 29.106C48.9718 28.686 50.1478 28.686 50.9038 29.106C51.0298 29.19 51.1558 29.274 51.2818 29.316C68.6698 39.354 83.8738 40.152 89.5858 40.026C90.3418 40.026 90.8458 40.152 91.2238 40.362C91.6438 40.614 91.8958 40.95 91.8538 41.328C91.6858 44.604 93.1138 53.424 110.502 63.462C110.628 63.546 110.796 63.63 110.922 63.714Z"
      fill="#BAE1D5"
    />
    <path
      d="M52.584 61.992C52.416 61.698 52.332 61.404 52.332 61.11V58.464"
      fill="#86CDB4"
    />
    <path
      d="M86.4782 60.984V63C86.4782 64.218 84.7982 65.184 82.7402 65.184V63.168C84.7982 63.126 86.4782 62.16 86.4782 60.984Z"
      fill="#026743"
    />
    <path
      d="M85.3855 59.43C86.0575 59.808 86.4775 60.354 86.4775 60.942C86.4775 62.16 84.7975 63.126 82.7395 63.126H39.2695L39.1855 49.854C39.1855 48.636 40.8655 47.67 42.9235 47.67C43.9735 47.67 44.8975 47.922 45.5695 48.3C46.2415 48.678 46.6615 49.224 46.6615 49.812L46.7035 58.758H82.6975C83.7475 58.8 84.7135 59.052 85.3855 59.43Z"
      fill="#008254"
    />
    <path d="M82.7395 63.126V65.184H39.2695V63.126H82.7395Z" fill="#026743" />
    <path
      d="M39.2695 63.126V65.184L39.1855 51.912V49.896L39.2695 63.126Z"
      fill="#008254"
    />
  </svg>
);

export default InsuranceShield;
